import { merge } from "lodash";
import * as React from "react";

export interface TextProps {
  text?: string;
  inline?: boolean;
  truncate?: boolean;
  fontSize?: string;
  fontWeight?: string | number;
  lineHeight?: string | number;
  onClick: () => void;
}

/** TODO: Typography component, any typography related components should extend from here */
export class Text<Props, State> extends React.Component<
  React.PropsWithChildren<TextProps> & Props,
  State & {}
> {
  colorAttribute = "color";

  classes(classes: Object = {}) {
    let { onClick, inline, truncate } = this.props;

    return merge(classes, {
      Text: true,
      clickable: onClick !== undefined,
      inline,
      truncate
    });
  }
  styles(styles: Object = {}) {
    let { fontSize, fontWeight, lineHeight } = this.props;

    return merge(styles, {
      fontSize,
      fontWeight,
      lineHeight
    });
  }

  renderChildren() {
    if (this.props.text) return this.props.text;

    return this.props.children;
  }

  render() {
    return (
      <div className={""} style={{}}>
        {this.renderChildren()}
      </div>
    );
  }
}
